/* eslint-disable comma-dangle */
<template>
  <div class="flex flex-col ">
    <show-alert
      @close="showTransactionDialog = false"
      title="Minting result"
      :opened="showTransactionDialog"
    >
      Your Wheelz have been minted, they should show in your wallet shortly.
      <br /><br />
      <div class="flex flex-row justify-center">
        <a class="font-bold text-blue-400" :href="'https://ftmscan.com/tx/'+txHash">TX hash</a>
      </div>
    </show-alert>
    <show-alert
      @close="showWalletDialog = false"
      title="Minting result"
      :opened="showWalletDialog"
    >
      {{ metamaskSelectedAddress }}
      <br /><br />
      <a class="text-center" href="#" @click.prevent="logout">Logout</a>
    </show-alert>
    <div class="block content p-4 flex-grow">

      <div class="flex flex-col md:flex-row justify-center items-center mt-2">
        <div class="sample-nft md:m-16 p-2 md:w-1/2 text-center">
          <img src="https://fantomwheelz.com/assets/images/mint_out_frontpage_01.png" />
        </div>
        <div class="items-center md:w-1/5 text-center">
          <br />
          <!--
        <div class="mb-4 ">
          The mint price will be dynamic.
          <br /><br />
          <div class="flex-col flex mx-auto w-3/4">
            <div class="flex-row flex justify-between">
              <div>1-1000</div>
              <div>280 FTM</div>
            </div>
            <div class="flex-row flex justify-between">
              <div>1001-2000</div>
              <div>330 FTM</div>
            </div>
            <div class="flex-row flex justify-between">
              <div>2001-3000</div>
              <div>380 FTM</div>
            </div>
          </div>

          </div>
          -->
          <!--
          <strong
            >{{ mintedCount }} of {{ totalCount }} minted ({{ leftCount }} left).</strong
          >
          -->
            <strong>ALL 3000 SOLD OUT!</strong>
            <br />
            <br />
            You can still buy these from the NFT marketplaces.
            <a href="https://nftkey.app/collections/fantomwheelz/">Go to NFTKey -marketplace</a>
          <br />
          <br />
          <div class="border-t-8 border-l-8 border-yellow-400 m-0 p-0">
          <button
            :disabled="mintButtonClicked"
            @click="() => onClicked(1)"
            class="w-full text-lg font-bold uppercase px-12 py-2 hover:border-yellow-400 border-b-8 border-r-8 border-yellow-600 bg-red-600 text-white block"
          >
          SOLD OUT
          </button>
          </div>
          <div class="text-center text-sm">{{ roundPrice(getPrice(1)) }} FTM</div>
          <br />
          <div class="border-t-8 border-l-8 border-yellow-400 m-0 p-0">
          <button
            :disabled="mintButtonClicked"
            @click="() => onClicked(10)"
            class="w-full text-lg font-bold uppercase px-12 py-2 hover:border-yellow-400  border-b-8  border-r-8 border-yellow-600 bg-red-600 text-white block"
          >
          SOLD OUT
          </button>
          </div>
          <div class="text-sm text-center">
            {{ roundPrice(getPrice(10)) }}*10 = {{ roundPrice(getPrice(10) * 10) }} FTM
          </div>
          <br />
          <div class="border-t-8 border-l-8 border-yellow-400 m-0 p-0">
          <button
            :disabled="mintButtonClicked"
            @click="() => onClicked(50)"
            class="w-full text-lg font-bold uppercase px-12 py-2  hover:border-yellow-400 border-b-8  border-r-8 border-yellow-600 bg-red-600 text-white block"
          >
          SOLD OUT
          </button>
          </div>
          <div class="text-sm text-center">
            {{ roundPrice(getPrice(50)) }}*50 = {{ roundPrice(getPrice(50) * 50) }} FTM
          </div>
          <br />
        </div>
      </div>
      <!--
          <div :class="countdownStyles">{{ countdown }}</div>
          -->
      <div class="flex flex-row justify-center">
        <div class="md:w-3/5 text-lg text-justify mt-4">
          Welcome to Fantom Wheelz, these are wheelz with character! Each Wheelz have
          their custom attributes and they are hand drawn by a true artist.
          <br /><br />No computer gimmicky, except in randomizing these beauties together.
          There are 7 unique car brands, 10 attributes in each car and a handful of
          variants in each attribute. In total there are OVER 250 million possible
          combinations - so your Fantom Wheelz is truly unique. <br /><br />
          For <strong>Series One</strong> we have selected {{ totalCount }} of them for you
          to admire, enjoy and collect. <br /><br />
          Why <a class="text-blue-800 hover:underline" href="https://fantom.finance/">Fantom Network</a>? It's fast, secure and
          scalable. <br /><br />
          <h2 class="text-xl font-bold">Mint yours NOW!</h2>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { ethers } from 'ethers'
import ShowAlert from '@components/ShowAlert.vue'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

import {
  targetNetwork,
  mintStart,
  mintPrice,
  isMetaMaskInstalled,
  isMetaMaskConnected,
  getContract,
  apiurl,
  connectWallet,
} from '../walletHelpers.js'

dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.extend(duration)

export default {
  name: 'Home',
  props: {},
  data: function () {
    return {
      countdown: '',
      redAlert: false,
      contract: null,
      mintedCount: 0,
      showWalletDialog: false,
      metamaskFailed: false,
      showTransactionDialog: false,
      txHash: null,
      totalCount: 3000,
      correctNetwork: false,
      price: null,
      mintButtonClicked: false,
      mintingAllowed: false,
      later: null,
    }
  },
  methods: {
    getAmountMinted: function () {
      // If ethereum is null, find amount of minted without it.
      fetch(apiurl + '/wheelz/get_minted_count')
        .then(r => r.json())
        .then(_mintedCount => {
          this.mintedCount = _mintedCount
        })
    },
    onClicked: function (howMany) {
      let price = null
      alert('Sold out!')
      this.mintButtonClicked = false
      return
      this.contract = getContract()
      switch (howMany) {
        case 1:
          price = this.getPrice(1).toString()
          this.contract
            .mintOne({ value: ethers.utils.parseEther(price) })
            .then((ret) => {
              this.showTransactionDialog = true
              this.mintButtonClicked = false
              this.txHash = ret.hash
            })
            .catch((err) => {
              this.mintButtonClicked = false
              if (err.data != null) {
                alert(err.data.message)
              } else {
                alert(
                  err.code +
                    ': ' +
                    err.operation +
                    ' ' +
                    err.reason +
                    '\n\n' +
                    'Check that you have connected your metamask'
                )
              }
            })
          break

        case 10:
          price = (this.getPrice(10) * 10).toString()
          this.contract
            .mintTen({ value: ethers.utils.parseEther(price) })
            .then((ret) => {
              this.mintButtonClicked = false
              this.showTransactionDialog = true
              this.txHash = ret.hash
            })
            .catch((err) => {
              this.mintButtonClicked = false
              if (err.data != null) {
                alert(err.data.message)
              } else {
                alert(
                  err.code +
                    ': ' +
                    err.operation +
                    ' ' +
                    err.reason +
                    '\n\n' +
                    'Check that you have connected your metamask'
                )
              }
            })
          break

        case 50:
          price = (this.getPrice(50) * 50).toString()
          this.contract
            .mintFifty({ value: ethers.utils.parseEther(price) })
            .then((ret) => {
              this.mintButtonClicked = false
              this.showTransactionDialog = true
              this.txHash = ret.hash
            })
            .catch((err) => {
              this.mintButtonClicked = false
              if (err.data != null) {
                alert(err.data.message)
              } else {
                alert(
                  err.code +
                    ': ' +
                    err.operation +
                    ' ' +
                    err.reason +
                    '\n\n' +
                    'Check that you have connected your metamask'
                )
              }
            })
          break
      }
      //}
    },
    roundPrice: function (price) {
      return Math.round(price * 100) / 100
    },
    getPrice: function (amt = 1) {
      return this.price
      /*
      switch (amt) {
        case 1:
          return this.price
        case 10:
          return this.price * 0.95
        case 50:
          return this.price * 0.9
      }
      return Math.round(this.price * 100) / 100
      */
    },
  },
  computed: {
    metamaskSelectedAddress: () => {
      const { ethereum } = window
      if (ethereum == null) {
        this.metamaskFailed = true
      } else {
        return ethereum.selectedAddress
      }
    },

    leftCount: function () {
      return this.totalCount - this.mintedCount
    },
  },
  mounted () {
    this.price = mintPrice
    const { ethereum } = window
    this.getAmountMinted()

    if (ethereum != null) {
      ethereum.on('chainChanged', () => {
        // Recommendation is to reload the page
        window.location.reload()
      })
      ethereum.request({ method: 'eth_chainId' }).then((chainId) => {
        if (chainId !== targetNetwork.id) {
          alert('Please change to ' + targetNetwork.name + '!')
          this.correctNetwork = false
        } else {
          this.correctNetwork = true
          isMetaMaskConnected()
            .then(isConnected => {
              const contract = getContract()
              contract
                .mintedCount()
                .then((ret) => {
                  this.mintedCount = ret.toNumber()
                })
                .catch((err) => alert(err))

              contract.on('Minted', (tokenId, minter, amount) => {
                this.mintedCount = tokenId.toNumber()
              })
            })
        }
      })
    } else {
      alert('If you want to mint and see the NFTs, you need metamask to be installed')
    }
  },
  components: {
    ShowAlert,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/HomePage.vue